<template>
  <button class="main-button solid font-size-14" :class="[color]" :style="{width,height}">
    <span class="hover-background"></span>
    <span class="text" :style="{justifyContent:icon==='none'?'center':'space-between'}">
        <span>{{title}}</span>
        <i :class="icon" :style="{fontSize:iconSize}" v-if="icon!='none'"></i>
    </span>
  </button>
</template>

<script>
export default {
  name: 'Title',
  props:{
    iconSize:{type:String,default:''},
    icon:{type:String,default:'el-icon-d-arrow-right'},
    color:{type:String,default:''},
    title:{type:String,default:''},
    width:{type:String,default:''},
    height:{type:String,default:''}
  },
  data(){
    return {
     
    }
  }
}
</script>

<style scoped>
.font-size-14 {
    font-size: .72916667vw;
}
.main-button {
  width: 9.375vw;
  height: 2.5vw;
  overflow: hidden;
  -webkit-transition: color .5s;
  transition: color .5s;
  position: relative;
  border: 1px solid #141414;
  line-height: 100%;
  text-align: center;
  cursor:pointer;
  background: #fff;
}
.main-button .hover-background {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 0;
  -webkit-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
}
.main-button .text {
  position:relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main-button:hover {
  color: #fff;
}
.main-button .hover-background {
  background: #141414;
}
.main-button:hover .hover-background {
  left: 0;
  right: auto;
  width: 100%;
}

.main-button.red{border: 1px solid #f50045; background:#f50045; color:#fff;}
.main-button.red:hover{color:#f50045;}
.main-button.red .hover-background{background: rgb(255,255,255);}

.main-button.transparent{border: 1px solid #fff; background:none; color:#fff;}
.main-button.transparent:hover{color:#fff;}
.main-button.transparent .hover-background{background: rgba(0,0,0,.5);}


@media (max-width: 991px){
.main-button {width: 24vw; height: 8vw; font-size: 2.93333333vw;}
.main-button .text { padding: 0 2.4vw;}
}

@media (min-width: 992px){
.main-button .text {padding: 0 1.5625vw;}
}
</style>